export function getIncludedCoverages({ coverages }) {
  return coverages.filter(coverage => coverage.included);
}
